var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('v-icon',{attrs:{"name":"cloud-lightning"}}),_c('h2',{staticClass:"m-b-3"},[_vm._t("title")],2),_c('p',[_vm._t("p")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }